import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { NewAccount } from '../../components/';
import {
  createAccount,
  getTrack,
  updateTrack,
} from '../../store/actions/Authentication';
import { createNewProject } from '../../store/actions/Dashboard';
import { addFlashMessage, clearMessage } from '../../store/actions/Flash';
import { routesAction } from '../../shared/helpers';

const Account = ({
  clientTabActive,
  dispatchAccountCreation,
  dispatchGetTrack,
  dispatchUpdateTrack,
  track,
}) => (
  <NewAccount
    phone_number_ddi="+1"
    clientTabActive={clientTabActive}
    onSubmit={dispatchAccountCreation}
    getTrack={dispatchGetTrack}
    updateTrack={dispatchUpdateTrack}
    track={track}
  />
);

Account.propTypes = {
  clientTabActive: PropTypes.bool,
  dispatchAccountCreation: PropTypes.func,
  dispatchGetTrack: PropTypes.func,
  dispatchUpdateTrack: PropTypes.func,
  track: PropTypes.object,
};

const mapStateToProps = state => ({
  clientTabActive: state.authentication.clientActiveTab,
  isFetching: state.authentication.isFetching,
  track: state.authentication.track,
});

const creatingUserSuccessMessage = dispatch => {
  dispatch(clearMessage());
  dispatch(addFlashMessage(['Your account has been created!'], 'success'));
};

const mapDispatchToProps = (dispatch, ownProps) => ({
  dispatchAccountCreation: (data, setSubmitting) => {
    data.name = `${data.first_name} ${data.last_name}`;
    dispatch(createAccount(data))
      .then(action => {
        if (action.type === 'AUTHENTICATION_SUCCESS') {
          const { user } = action.payload.data;

          if (user.type === 'Freelancer') {
            ownProps.history.push(routesAction.freelancerOnboarding());
            creatingUserSuccessMessage(dispatch);
          } else {
            dispatch(createNewProject(user.email)).then(responseAction => {
              if (responseAction.type === 'SELECT_PROJECT') {
                ownProps.history.push(
                  routesAction.onboarding(responseAction.payload.project_id),
                );
                creatingUserSuccessMessage(dispatch);
              }
            });
          }
        }
        setSubmitting(false);
      })
      .catch(() => setSubmitting(false));
  },
  dispatchGetTrack: () => {
    dispatch(getTrack());
  },
  dispatchUpdateTrack: data => {
    dispatch(updateTrack(data));
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Account);



// WEBPACK FOOTER //
// ./src/containers/Account/Account.js